<template>
    <component
        :is="entry.slug ? Nuxtlink : 'div'"
        :to="`/updates/${entry.slug}`"
        class="article-card"
    >
        <BaseImage
            v-if="image"
            :alt="image.alt"
            :src="image.url"
            :srcset="image.srcSet"
            :webp-srcset="image.srcSetWebp"
            :width="image.width || 656"
            :height="image.height || 656"
            class="article-card__image base-image--cover"
        />
        <div class="article-card__content">
            <span class="article-card__title">{{ entry.heroPreTitle }}</span>
            <span class="article-card__subtitle">{{ entry.heroTitle }}</span>

            <div class="article-card__actions">
                <BaseButton class="dn-button button--transparent-dark button--centered article-card__link">
                    Lees meer
                </BaseButton>
            </div>
        </div>
    </component>
</template>

<script setup lang="ts">
import type { UpdateEntryTypeSimpleFragment } from '~/types/craft-schema';

const props = defineProps<{
    entry: UpdateEntryTypeSimpleFragment;
}>();

const Nuxtlink = resolveComponent('NuxtLink');

const image = computed(() => getDefaultImageAssetHero(props.entry?.featuredImages?.[0] || props?.entry?.heroImages?.[0] || null));
</script>

<!--todo: Move styling to new file-->
<style lang="less">
.article-card {
    .link-clean();

    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: flex-end;

    aspect-ratio: 1/1;
    transition: transform .3s var(--transition-timingFunction-in-out);
    overflow: hidden;
    border-radius: .5rem;

    &:hover {
        transform: scale(.97);

        &:focus-visible {
            transform: scale(.97);
        }
    }

    &:focus-visible {
        transform: scale(.97);
        outline: 2px solid var(--color-lightest);

        [data-color-theme='light'] & {
            outline: 2px solid var(--color-darkest);
        }
    }
}

.article-card__content {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    gap: .5rem;
    padding: 0 1rem 1rem;
    background: var(--color-lightest);
    width: 100%;
    color: var(--color-darkest);
    overflow: visible;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(0deg, #FFF 00%, rgba(255, 255, 255, 0.00) 100%);
        transform: translateY(-99%);
        z-index: -1;
        pointer-events: none;
    }

    transition: transform var(--transition-fast);
    z-index: 2;
}

.article-card__title {
    .typography-label-medium();
}

.article-card__subtitle {
    .typography-h2();
}

.article-card__title,
.article-card__subtitle {
    width: 100%;
    white-space: wrap;
    text-align: center;
}

.dn-button.article-card__link {
    z-index: 10;
}

.article-card--slider {
    width: 21rem;
    height: 21rem;

    margin-right: .5rem;
}
</style>
